import React from 'react';
import { useDispatch } from 'react-redux';
import { AxiosResponse } from 'axios';

import { getBlockReleasesByNpi } from '@data/blockReleases/actionCreators/BlockReleaseActionCreators';
import {
	BlockReleaseRequest,
	BlockReleaseApiResponse,
} from '@data/blockReleases/types/BlockRelease.types';
import { ApiActionPayload } from '@interfaces/ApiAction/ApiActionPayload';

export const useGetBlockReleasesByNpi = () => {
	const [releases, setReleases] = React.useState<BlockReleaseApiResponse[]>([]);
	const dispatch = useDispatch();

	const getReleases = React.useCallback(
		(body: BlockReleaseRequest, overrides?: Partial<ApiActionPayload<BlockReleaseApiResponse[]>>) => {
			const onSuccess = (response: AxiosResponse<BlockReleaseApiResponse[]>) => {
				if (response.data.length > 0) {
					setReleases(response.data);
				}
			};
			dispatch(getBlockReleasesByNpi(body, { onSuccess, ...overrides }));
		},
		[dispatch],
	);

	return {
		releases,
		getReleases,
		setReleases,
	};
};
